<template>
  <v-row justify="center" class="mt-2">
    <v-pagination
      class="mb-2"
      v-model="currentPage"
      @next="goToStep"
      @prev="goToStep"
      :length="totalPages"
      :total-visible="5"
      @update:modelValue="goToStep"
    ></v-pagination>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
// import axios from "axios";

export default {
  name: "PaginationDynamic",
  props: {
    store: {
      type: String,
      required: true,
    },
    cust: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      notGoto: true,
    };
  },
  computed: {
    ...mapState({
      totalCount: (state) => state.paginations.totalCount,
      totalPages: (state) => state.paginations.totalPages,
      currentFilter: (state) => state.paginations.currentFilter,
      currentOrderFilter: (state) => state.paginations.currentOrderFilter,
      hasNext: (state) => state.paginations.hasNext,
      hasPrevious: (state) => state.paginations.hasPrevious,
      loadingDatatables: (state) => state.loadingTables,
      search: (state) => state.paginations.search,
    }),
    currentPage: {
      get() {
        return this.$store.state.paginations.currentPage;
      },
      set(value) {
        this.$store.commit("paginations/setCurrentPage", value);
      },
    },
  },
  methods: {
    goToStep(item) {
      this.$store.commit("setLoadingTables", true);
      var paginationParams = "";
      if (this.currentFilter != "" && this.currentOrderFilter != "") {
        paginationParams =
          "?pageNumber=" +
          item +
          "&orderBy=" +
          this.currentFilter +
          " " +
          this.currentOrderFilter +
          "";
      } else {
        paginationParams = "?pageNumber=" + item + "";
      }
      if (this.search != "") {
        paginationParams += "&search=" + this.search;
      }
      if (this.store == "products-customer") {
        paginationParams += "&Customer=" + this.cust;
      }
      const data = {
        text: paginationParams,
      };
      if (this.store == "products-customer") {
        this.$store
          .dispatch(`products/fetchProductForCustomer`, data)
          .then((response) => {
            this.$store.commit("setLoadingTables", false);
            this.$store.commit(
              "paginations/setItems",
              JSON.parse(response.headers.get("X-Pagination")),
            );
          });
      } else if (this.store == "orderOneStryker") {
        const dataToFetch = {
          pagination: paginationParams,
          customer: this.$store.state.users.selectedCustomer.id,
        };
        this.$store
          .dispatch(`ordersOneStryker/fetchCustommerCommands`, dataToFetch)
          .then((response) => {
            this.$store.commit("setLoadingTables", false);
            this.$store.commit(
              "paginations/setItems",
              JSON.parse(response.headers.get("X-Pagination")),
            );
          });
      } else if (this.store == "kpi") {
        // Ajouter ContractYear si défini dans le store
        let finalPaginationParams = paginationParams;
        const contractYear = this.$store.state.kpi.selectedContractYear;
        if (contractYear !== null && contractYear !== undefined) {
          finalPaginationParams += `&ContractYear=${contractYear}`;
        }

        const dataKpi = {
          text: finalPaginationParams,
        };

        this.$store
          .dispatch("kpi/fetchOrderOneStrykerStatistics", dataKpi)
          .then((response) => {
            this.$store.commit("setLoadingTables", false);
            this.$store.commit(
              "paginations/setItems",
              JSON.parse(response.headers.get("X-Pagination")),
            );
          });
      } else {
        this.$store
          .dispatch(`${this.store}/fetchAll`, data)
          .then((response) => {
            this.$store.commit("setLoadingTables", false);
            this.$store.commit(
              "paginations/setItems",
              JSON.parse(response.headers.get("X-Pagination")),
            );
          });
      }
    },
  },
};
</script>
